import { Controller } from "@hotwired/stimulus";

/**
 * Event Request Convert Controller
 *
 * Gates the Create Event button on the convert_confirm page behind the
 * acknowledgement checkboxes. Server-side guards in
 * Admin::EventRequestsController#convert are the source of truth; this
 * controller is UX-only.
 *
 * GR-3516: there can be two acknowledgements now, blocked dates and daily
 * capacity, and either can appear without the other. Every one shown has to be
 * ticked, so this reads all of them rather than the first.
 */
export default class extends Controller {
  static targets = ["acknowledgement", "submit"];

  toggleSubmit() {
    if (!this.hasSubmitTarget) return;
    this.submitTarget.disabled = !this.acknowledgementTargets.every((box) => box.checked);
  }
}
